import React, { useEffect, useState } from 'react'
import { translate } from 'react-i18next';
import { Row, Col, Form, Input, Button, Select, Upload, notification } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { isEmpty, findIndex, isUndefined } from 'lodash';
import { useSelector } from 'react-redux';
import {
    validateEmail,
    sendemailHttpClient,
    routersHelper
} from '../../helpers'
import ContactSubmit from './ContactSubmit'
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import PopupCancelMemberShip from './../../helpers/PopupCancelMemberShip'

function ContactForm({ t }) {
    const [form] = Form.useForm();
    const { useRouter } = routersHelper
    const router = useRouter()
    const { contact } = router.query
    const lang = useSelector(state => state.language)
    const [submitContact, setsubmitContact] = useState(false)
    const [subjectCode, setSubjectCode] = useState('')
    const [saleOnly, setSaleOnly] = useState(false)
    const [checkbox, setCheckbox] = useState({
        contactback: false
    })

    const [nameError, setnameError] = useState({
        isError: false,
        message: null
    })
    const [emailError, setemailError] = useState({
        isError: false,
        message: null,
        invalidEmail: false
    })
    //  const [email, setemailData] = useState("")
    const [commentError, setcommentError] = useState({
        isError: false,
        message: null
    })

    const [subjectError, setsubjectError] = useState({
        isError: false,
        message: null
    })

    const [phoneError, setphoneError] = useState({
        isError: false,
        message: null,
        invalidPhone: false
    })

    // detail input
    const [detailInput, setDetailInput] = useState({
        value: null,
        length: 0
    })



    const onFinish = async values => {
        //let tenPhone = values.phone.substr(2,12);
        if (!isEmpty(values)) {
            
            if (phoneError.invalidPhone) {
                return;
            }
            /**
            *  Issue report
            */
            let sub = '';
            if (values.subject === "发行报告") {
                sub = 'แจ้งปัญหาการใช้งาน';
            } else if (values.subject === 'Issue report') {
                sub = 'แจ้งปัญหาการใช้งาน';
            } else if (values.subject === 'แจ้งปัญหาการใช้งาน') {
                sub = 'แจ้งปัญหาการใช้งาน';
            } 
            /**
            *  How to apply service
            */
            else if (values.subject === '如何申请服务') {
                sub = 'สนใจสมัครบริการ';
            } else if (values.subject === 'How to apply service') {
                sub = 'สนใจสมัครบริการ';
            } else if (values.subject === 'สนใจสมัครบริการ') {
                sub = 'สนใจสมัครบริการ';
            } 
            /**
            *  Recommend services
            */
            else if (values.subject === '推荐服务') {
                sub = 'แนะนำการบริการ';
            } else if (values.subject === 'Recommend services') {
                sub = 'แนะนำการบริการ';
            } else if (values.subject === 'แนะนำการบริการ') {
                sub = 'แนะนำการบริการ';
            } 

            /**
            *  Other
            */
            else if (values.subject === '其他') {
                sub = 'อื่น ๆ';
            } else if (values.subject === 'Other') {
                sub = 'อื่น ๆ';
            } else if (values.subject === 'อื่น ๆ') {
                sub = 'อื่น ๆ';
            } 
            const urlContact = `${window._env_.contact}api/v1/sendemail`
            const filter = Array.isArray(values.files) && values.files.filter((item) => item.status === "error");

            if (filter === false) {

                try {

                    if (checkbox.contactback === true) {
                        values['contactback'] = "Yes"
                    } else if (checkbox.contactback === false) {
                        values['contactback'] = "No"
                    }
                    const { name, email, phone, comment, contactback } = values
                    const formData = new FormData();
                    formData.append("contactback", contactback)
                    formData.append("comment", comment)
                    formData.append("phone", `+${phone}`)
                    formData.append("subjectcode", subjectCode)
                    formData.append("subject", sub)
                    formData.append("email", email)
                    formData.append("name", name)
                    // console.log(values)
                   const send = await sendemailHttpClient(urlContact, formData)

                    if (send.status === 200) {
                        setsubmitContact(true)
                    }

                } catch (error) {
                    console.log('send mail error')
                }


            }
            if (filter.length === 0) {
                let result_size = 0
                let status = false;
                Array.isArray(values.files) && values.files.forEach((v) => {

                    result_size += parseInt(v.size)

                    if (result_size > 8388608) {
                        //setTotalSize({size: result_size, status: true})
                        status = true
                    } else if (result_size <= 8388608) {
                        //  setTotalSize({size: result_size, status: false})
                        status = false
                    }

                })

                if (status === false) {

                    try {

                        if (checkbox.contactback === true) {
                            values['contactback'] = "Yes"
                        } else if (checkbox.contactback === false) {
                            values['contactback'] = "No"
                        }
                        const { name, email, phone, comment, contactback, files } = values
                        const formData = new FormData();
                        Array.isArray(files) && files.forEach((img) => {
                            formData.append("files", img.originFileObj, img.originFileObj.name)
                        })

                        formData.append("contactback", contactback)
                        formData.append("comment", comment)
                        formData.append("phone", `+${phone}`)
                        formData.append("subjectcode", subjectCode)
                        formData.append("subject", sub)
                        formData.append("email", email)
                        formData.append("name", name)

                        const send = await sendemailHttpClient(urlContact, formData)
                        if (send.status === 200) {
                            setsubmitContact(true)
                        }
                    } catch (error) {
                        console.log('send mail error')
                    }


                } else if (status === true) {
                    notification.error({
                        message: t("contact_page_form.upload_more_mb"),
                        placement: "bottomRight"
                    });
                }


            } else if (filter.length >= 1) {
                notification.error({
                    message: t("contact_page_form.upload_description"),
                    placement: "bottomRight"
                });
            }

        } else {
            console.log('false')
        }
    };

    const normFile = e => {
        console.log('e', e.file)
        if (e.file.type.search("image/") >= 0) {
            let s = e.file.size
            if (parseInt(s) > 1505335) {
                let index = findIndex(e.fileList, function (o) { return o.uid === e.file.uid })
                if (index >= 0) {
                    e.fileList[index].status = "error"
                    e.fileList[index].response = ""

                }

            }
            if (e.file.name.match(/\.(gif)$/)) {
                let index = findIndex(e.fileList, function (o) { return o.uid === e.file.uid })
                if (index >= 0) {
                    e.fileList[index].status = "error"
                    e.fileList[index].response = ""

                }
            }

        } 
        if (e.file.type.search("application/") >= 0){
            if (e.file.name.match(/\.(mp4|mp3|txt|gif|exe|pdf|xlxs|xlx|doc|docx|zip)$/)) {
                let index = findIndex(e.fileList, function (o) { return o.uid === e.file.uid })
                if (index >= 0) {
                    e.fileList[index].status = "error"
                    e.fileList[index].response = ""

                }
            }
        }
        if (e.file.type.search("video/") >= 0){
            if (e.file.name.match(/\.(mp4|mp3)$/)) {
                let index = findIndex(e.fileList, function (o) { return o.uid === e.file.uid })
                if (index >= 0) {
                    e.fileList[index].status = "error"
                    e.fileList[index].response = ""

                }
            }
        }
        if (e.file.type === ""){
            let index = findIndex(e.fileList, function (o) { return o.uid === e.file.uid })
                if (index >= 0) {
                    e.fileList[index].status = "error"
                    e.fileList[index].response = ""

            }
        }

        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };



    const handleSubject = (value) => {

        // console.log('sale', {"sale": contact})
        
        if ( value === t('contact_page_form.input_select_5')) {
            setSubjectCode('support')
        } else if (value === t('contact_page_form.input_select_2')) {
            setSubjectCode('sale')
        } else if (value === t('contact_page_form.input_select_4')) {
            setSubjectCode('feedback')
        } else if (value === t('contact_page_form.input_select_3')) {
            setSubjectCode('others')
        }
        // if (parseInt(value) === 3) {
        //     ///setrequireSubject(true)
        // } else {
        //     //setrequireSubject(false)
        // }
    }


    const handleActiveContact = e => {
        if (e.target.checked) {
            setCheckbox({
                ...checkbox,
                contactback: !checkbox.contactback
            })
        } else {
            setCheckbox({
                ...checkbox,
                contactback: !checkbox.contactback
            })

        }
    }

    /**
     * Sumit modal form when fail.
     * @param {*} errorInfo 
     */
    const onFinishFailed = errorInfo => {
        // console.log('onFinishFailed', errorInfo)
        if (errorInfo.values.name === undefined || errorInfo.values.name === "") {
            setnameError({ isError: true })
        }
        if (errorInfo.values.comment === undefined || errorInfo.values.comment === "") {
            setcommentError({ isError: true })
        }
        if (errorInfo.values.subject === undefined || errorInfo.values.subject === "") {
            setsubjectError({ isError: true })
        }
        if (errorInfo.values.phone === undefined || errorInfo.values.phone === "") {
            setphoneError({ isError: true, invalidPhone: false  })
        }
        if (errorInfo.values.email === undefined || errorInfo.values.email === "") {
            setemailError({ isError: true, invalidEmail: false })
        }

      
       
    };

    /**
   * handle Detail show detail character length.
   * @param {*} e 
   */
    const handleDetail = (e) => {
        setDetailInput({
            value: e.target.value,
            length: e.target.value.length
        })
    }

    const handleLang = () => {
        if (lang === "en") {
            return 'us'
        } else if (lang === "th") {
            return 'th'
        } else if (lang === 'cn') {
            return 'cn'
        }
    }

    const handleOnChangePhone = (e) => {
        const formVal = e.target.value.length //form.getFieldsValue(['phone'])
        //console.log('e',e.target.value.length)
        // console.log('e on change phone',formVal.phone.length)
        // console.log('e phone',formVal.phone)
        
        // let tenPhone = formVal.phone.slice(2,12);
        // let more = formVal.phone.slice(2,14);
        // console.log('some',tenPhone);
        // console.log('some',tenPhone.length);
        // console.log('more', more)
        // console.log('more', more.length)
       
        // console.log('formValu', formVal.phone.includes("66"))
        if (lang === "th" && formVal < 15) {
            setphoneError({isError: false, invalidPhone: true})
        }
        if (lang === "th" && formVal === 15) {
            setphoneError({isError: false, invalidPhone: false})
        } 
      
        if (lang === "th" && (formVal > 15)) {
            setphoneError({isError: false, invalidPhone: true})
        } 
        
        if (lang === "en" && formVal < 5) {
            setphoneError({isError: false, invalidPhone: true})
        } else if (lang === "en" && (formVal > 5 && formVal < 17)) {
            setphoneError({isError: false, invalidPhone: false})
        } 

        if (lang === "cn" && formVal < 5) {
            setphoneError({isError: false, invalidPhone: true})
        } else if (lang === "cn" && (formVal > 5 && formVal < 16)) {
            setphoneError({isError: false, invalidPhone: false})
        } 
    }

    // const validatorPhone = (e) => {
    //     console.log('validatorPhone', e.length)
    //     if (e.length < "5") {
    //         setphoneError({isError: false, invalidPhone: true})
    //     } else {
    //         setphoneError({isError: false, invalidPhone: false})
    //     }
    // }


    const handleHelpEmail = () => {
        if (emailError.isError) {
            return t('contact_page_form.form_validate_email')
        }
        if (emailError.invalidEmail) {
            return t('contact_page_form.invalid_email')
        }
    }

    const handleFormEmail = () => {
        if (emailError.isError || emailError.invalidEmail) {
            return "error"
        } else {
            return "success"
        }

    }

    const handleFormPhone = () => {
        if (phoneError.isError || phoneError.invalidPhone) {
            return "error"
        } else {
            return "success"
        }
    }

    const handleValidPhone = () => {
        if (phoneError.isError || phoneError.invalidPhone) {
            return "phone-style border-red"
        } else {
            return "phone-style"
        }
    }

    const handleReuiredEmail = () => {
        if (emailError.isError ) {
            return [
                { required: true, message: t('contact_page_form.form_validate_email') }
            ]
        } else {
            return [
                { required: false, message: "" }
            ]
        }
    }

    const handleRulesPhone = () => {
        if(phoneError.isError) {
            return [
                    { required: true, message: t('contact_page_form.form_validate_phone_number') }
                ]
        } else {
            return [
                { required: false, message: "" }
            ]
        }
    }

    const handleHelpPhone = () => {
        if (phoneError.isError) {
            return t('contact_page_form.form_validate_phone_number')
        }
        if (phoneError.invalidPhone) {
            return t('contact_page_form.invalid_phone')
        }
    }


    const dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess("OK")
        }, 0);
    }


    useEffect(() => {
        const formVal = form.getFieldsValue(['subject'])
        if (!isUndefined(formVal.subject)) {
           
            if(lang === "th") {
               /**
                 *  Issue report
                 */
                if (formVal.subject === "发行报告") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_5')}`
                    })
                }
                if (formVal.subject === "แจ้งปัญหาการใช้งาน") { 
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_5')}`
                    })
                }
                if (formVal.subject === "Issue report") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_5')}`
                    })
                }


                 /**
                 *  How to apply service
                 */
                if (formVal.subject === "如何申请服务") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_2')}`
                    })
                }
                if (formVal.subject === "สนใจสมัครบริการ") { 
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_2')}`
                    })
                }
                if (formVal.subject === "How to apply service") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_2')}`
                    })
                }



                 /**
                 *  Recommend services
                 */
                if (formVal.subject === "推荐服务") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_4')}`
                    })
                }
                if (formVal.subject === "แนะนำการบริการ") { 
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_4')}`
                    })
                }
                if (formVal.subject === "Recommend services") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_4')}`
                    })
                }




                /**
                 *  Other
                 */
                if (formVal.subject === "其他") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_3')}`
                    })
                }
                if (formVal.subject === "อื่น ๆ") { 
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_3')}`
                    })
                }
                if (formVal.subject === "Other") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_3')}`
                    })
                }
                
            } else if (lang === "en") {
               
                /**
                 *  Issue report
                 */
                if (formVal.subject === "发行报告") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_5')}`
                    })
                }
                if (formVal.subject === "แจ้งปัญหาการใช้งาน") { 
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_5')}`
                    })
                }
                if (formVal.subject === "Issue report") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_5')}`
                    })
                }



                 /**
                 *  How to apply service
                 */
                if (formVal.subject === "如何申请服务") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_2')}`
                    })
                }
                if (formVal.subject === "สนใจสมัครบริการ") { 
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_2')}`
                    })
                }
                if (formVal.subject === "How to apply service") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_2')}`
                    })
                }


                 /**
                 *  Recommend services
                 */
                if (formVal.subject === "推荐服务") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_4')}`
                    })
                }
                if (formVal.subject === "แนะนำการบริการ") { 
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_4')}`
                    })
                }
                if (formVal.subject === "Recommend services") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_4')}`
                    })
                }

                /** 
                 * Other
                 */
                if (formVal.subject === "อื่น ๆ") { 
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_3')}`
                    })
                }
                if (formVal.subject === "Other") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_3')}`
                    })
                }
                if (formVal.subject === "其他") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_3')}`
                    })
                }
               
            } else if (lang === "cn") {
                 /**
                 *  Issue report
                 */
                if (formVal.subject === "联系客服支持") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_5')}`
                    })
                }
                if (formVal.subject === "แจ้งปัญหาการใช้งาน") { 
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_5')}`
                    })
                }
                if (formVal.subject === "Issue report") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_5')}`
                    })
                }



                 /**
                 *  How to apply service
                 */
                if (formVal.subject === "如何申请服务") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_2')}`
                    })
                }
                if (formVal.subject === "สนใจสมัครบริการ") { 
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_2')}`
                    })
                }
                if (formVal.subject === "How to apply service") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_2')}`
                    })
                }


                 /**
                 *  Recommend services
                 */
                if (formVal.subject === "推荐服务") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_4')}`
                    })
                }
                if (formVal.subject === "แนะนำการบริการ") { 
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_4')}`
                    })
                }
                if (formVal.subject === "Recommend services") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_4')}`
                    })

                }
                


                /**
                 * Other
                 */
                if (formVal.subject === "其他") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_3')}`
                    })
                }
                if (formVal.subject === "อื่น ๆ") { 
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_3')}`
                    })
                }
                if (formVal.subject === "Other") {
                    form.setFieldsValue({
                        subject: `${t('contact_page_form.input_select_3')}`
                    })
                }
            }

            
            
        }
    }, [form, lang, t])

    useEffect(() => {
        if (!isUndefined(contact) && contact === "sale") {
            form.setFieldsValue({
                subject: `${t('contact_page_form.input_select_2')}`
            })
            setSaleOnly(true)
            setSubjectCode('sale')
            setsubjectError({isError: false})
            
        }
    }, [contact,form, t])

    const { Option } = Select;

    return (
        submitContact ? (
            <ContactSubmit />
        ) : (
                <Row justify="center">
                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                        <Row justify="center">
                            <Col span={14}>
                                <Form
                                    form={form}
                                    layout="horizontal"
                                    onFinish={onFinish}
                                    className="form-contact-page"
                                    onFinishFailed={onFinishFailed}
                                >
                                    {
                                        nameError.isError ? (
                                            <Form.Item
                                                name="name"
                                                validateStatus="error"
                                                help={t('contact_page_form.form_validate_username')}
                                                rules={[{ required: true, message: '' }]}
                                            >
                                                <Input
                                                    type="text"
                                                    maxLength="100"
                                                    placeholder={t('contact_page_form.input_1')}
                                                    onChange={() => setnameError({ isError: false })}
                                                />
                                            </Form.Item>
                                        ) : (
                                                <Form.Item
                                                    name="name"
                                                    help={nameError.isError && t('contact_page_form.form_validate_username')}
                                                    rules={[{ required: true, message: t('contact_page_form.form_validate_username') }]}
                                                >
                                                    <Input
                                                        type="text"
                                                        maxLength="100"
                                                        placeholder={t('contact_page_form.input_1')}

                                                    />

                                                </Form.Item>
                                            )
                                    }

                                    {
                                        // emailError.isError ?
                                        //     <Form.Item
                                        //         name="email"
                                        //         validateStatus="error"
                                        //         help={t('contact_page_form.form_validate_email')}
                                        //         rules={[
                                        //             { type: 'email', message: '' },
                                        //             { required: true, message: t('contact_page_form.form_validate_email') }
                                        //         ]}
                                        //     >
                                        //         <Input
                                        //             type="email"
                                        //             placeholder={t('contact_page_form.input_2')}
                                        //             onChange={() => setemailError({ isError: false })}
                                        //         />
                                        //     </Form.Item>
                                        //     : (
                                                <Form.Item
                                                    name="email"
                                                   // validateStatus={emailError.invalidEmail ? "error" : "success"}
                                                   validateStatus={handleFormEmail()}
                                                    help={handleHelpEmail()}
                                                    // rules={[
                                                    //   //  { type: 'email', message: (emailError.invalidEmail ? "error": "") },
                                                    //     { required: true, message: t('contact_page_form.form_validate_email') }
                                                    // ]}
                                                    rules={handleReuiredEmail()}
                                                >
                                                    <Input
                                                        type="text"
                                                        placeholder={t('contact_page_form.input_2')}
                                                        onBlur={(e) =>
                                                            !validateEmail(e.target.value) && (e.target.value !== "") ?
                                                                setemailError({ isError: false, invalidEmail: true })
                                                                :
                                                                setemailError({ isError: false, invalidEmail: false })

                                                        }
                                                        onChange={(e) => 
                                                            (e.target.value === "" || isUndefined(e.target.value)) &&
                                                                setemailError({ isError: false, invalidEmail: false })
                                                            
                                                        }
                                                    />
                                                    {/* <span className="vroom-name-error">{emailError.invalidEmail && t('contact_page_form.invalid_email')}</span> */}
                                                </Form.Item>
                                            // )
                                    }




                                    {/* <Form.Item
                                        name="phone"
                                        rules={[
                                            { required: true, message: t('contact_page_form.form_validate_phone_number') }
                                        ]}>
                                        <Input
                                            placeholder={t('contact_page_form.input_3')}
                                        />
                                    </Form.Item> */}
                                    {
                                        // phoneError.isError ? (
                                        //     <Form.Item
                                        //         name="phone"
                                        //         validateStatus="error"
                                        //         help={t('contact_page_form.form_validate_phone_number')}
                                        //         rules={[
                                        //             { required: true, message: '' }
                                        //         ]}
                                        //     >

                                        //         <ReactPhoneInput
                                        //             containerClass={phoneError.isError ? "phone-style border-red": "phone-style"}
                                        //             name="phone"
                                        //             value={'phone'}
                                        //             placeholder={t('contact_page_form.input_3')}
                                        //             country={handleLang()}
                                        //             onChange={(e) => validatorPhone(e)}
                                                    
                                        //         />
                                        //     </Form.Item>
                                        // ) : (
                                                <Form.Item
                                                   // validateStatus={phoneError.invalidPhone ? "error" : "success"}
                                                   validateStatus={handleFormPhone()} 
                                                   name="phone"
                                                    help={handleHelpPhone()}
                                                   // help={subjectError.isError && t('contact_page_form.form_validate_phone_number')}
                                                    // rules={[
                                                    //     { required: true, message: t('contact_page_form.form_validate_phone_number') }
                                                    // ]}
                                                    rules={handleRulesPhone()}
                                                >
                                                    <ReactPhoneInput
                                                        containerClass={handleValidPhone()}
                                                        name="phone"
                                                        value={'phone'}
                                                        placeholder={t('contact_page_form.input_3')}
                                                        country={handleLang()}
                                                        onChange={(e) =>
                                                           
                                                            (e === "" || isUndefined(e)) &&
                                                                setphoneError({isError: false, invalidPhone: false})
                                                        }
                                                        onBlur={(e) => handleOnChangePhone(e)}
                                                       
                                                    />
                                                </Form.Item>
                                            // )
                                    }


                                    {
                                        subjectError.isError ? (
                                            <Form.Item
                                                name="subject"
                                                validateStatus="error"
                                                help={t('contact_page_form.form_validate_subject')}
                                                rules={[{ required: true, message: '' }]}
                                            >
                                                <Select
                                                    placeholder={t('contact_page_form.input_4')}
                                                    allowClear
                                                    onChange={() => setsubjectError({ isError: false })}
                                                >
                                                    <Option value={t('contact_page_form.input_select_2')}>{t('contact_page_form.input_select_2')}</Option>
                                                    <Option style={{display: saleOnly ? "none": ""}} value={t('contact_page_form.input_select_5')}>{t('contact_page_form.input_select_5')}</Option>
                                                    
                                                    <Option style={{display: saleOnly ? "none": ""}} value={t('contact_page_form.input_select_4')}>{t('contact_page_form.input_select_4')}</Option>
                                                    {/* <Option style={{display: saleOnly ? "none": ""}} value={t('contact_page_form.input_select_3')}>{t('contact_page_form.input_select_3')}</Option> */}

                                                </Select>
                                            </Form.Item>
                                        ) : (
                                            <Form.Item
                                                name="subject"
                                                help={subjectError.isError&&t('contact_page_form.form_validate_subject')}
                                                rules={[{ required: true, message: t('contact_page_form.form_validate_subject') }]}
                                            >
                                                <Select
                                                    placeholder={t('contact_page_form.input_4')}
                                                    allowClear
                                                    onChange={handleSubject}
                                                >   
                                                    <Option value={t('contact_page_form.input_select_2')}>{t('contact_page_form.input_select_2')}</Option>
                                                    <Option style={{display: saleOnly ? "none": ""}} value={t('contact_page_form.input_select_5')}>{t('contact_page_form.input_select_5')}</Option>
                                                
                                                    <Option style={{display: saleOnly ? "none": ""}} value={t('contact_page_form.input_select_4')}>{t('contact_page_form.input_select_4')}</Option>
                                                    {/* <Option style={{display: saleOnly ? "none": ""}} value={t('contact_page_form.input_select_3')}>{t('contact_page_form.input_select_3')}</Option> */}
                                                   
                                                </Select>
                                            </Form.Item>
                                        )
                                    }
                                    {
                                        commentError.isError ? (
                                            <>
                                                <Form.Item
                                                    name="comment"
                                                    validateStatus="error"
                                                    help={t('contact_page_form.from_validate_message')}
                                                    rules={[{ required: true, message: '' }]}
                                                >
                                                    <Input.TextArea
                                                        placeholder={t('contact_page_form.input_5')}
                                                        rows={5}
                                                        maxLength={10000}
                                                        onChange={() => setcommentError({ isError: false })}
                                                    />
                                                </Form.Item>
                                                <small span={24} style={{ marginTop: '-20px', float: 'right', color: detailInput.length >= 9900 ? '#FF0000' : '#BDBDBD' }}>
                                                    {`${detailInput.length}/10000`}
                                                </small>
                                            </>
                                        ) : (
                                                <>
                                                    <Form.Item
                                                        name="comment"
                                                        help={commentError.isError && t('contact_page_form.from_validate_message')}
                                                        rules={[{ required: true, message: t('contact_page_form.from_validate_message') }]}
                                                    >
                                                        <Input.TextArea
                                                            maxLength={10000}
                                                            placeholder={t('contact_page_form.input_5')}
                                                            rows={5}
                                                            onChange={(e) => handleDetail(e)}
                                                        />

                                                    </Form.Item>
                                                    <small span={24} style={{ marginTop: '-20px', float: 'right', color: detailInput.length >= 9900 ? '#FF0000' : '#BDBDBD' }}>
                                                        {`${detailInput.length}/10000`}
                                                    </small>
                                                </>
                                            )
                                    }


                                    <Form.Item
                                        name="files"
                                        valuePropName="fileList"
                                        extra={t('contact_page_form.upload_description')}
                                        getValueFromEvent={normFile}
                                    >

                                        <Upload
                                            accept="image/png, image/jpg, image/JPG, image/JPEG, image/jpeg, image/PNG"
                                            name="files"
                                            customRequest={dummyRequest}
                                            //action={`/reservation`}
                                            beforeUpload={(file) => {
                                                const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/JPG' || file.type === 'image/JPEG' || file.type === 'image/PNG';
                                                if (!isJPG) {
                                                    notification.error({
                                                        message: t("contact_page_form.upload_description"),
                                                        placement: "bottomRight"
                                                    });
                                                    return false;
                                                } else {
                                                    return true;
                                                }
                                            }}
                                            listType="picture"
                                        >
                                            <Button className="btn-upload-img" icon={<UploadOutlined />}>{t('contact_page_form.input_6')}</Button>
                                        </Upload>

                                    </Form.Item>


                                    <Row className="modal-custom-checkbox" style={{ marginBottom: '24px' }}>
                                        <Col span={2} className="modal-active-password">
                                            <label className="modal-container-checkbox">
                                                <input type="checkbox" id="v-room-active-checkbox" checked={checkbox.contactback} onChange={(e) => handleActiveContact(e)} />
                                                <span className="checkmark"></span>
                                            </label>
                                        </Col>
                                        <Col span={22}>
                                            <label>{t("contact_page_form.checkbox_to_contact")}</label>
                                        </Col>
                                    </Row>

                                    <Form.Item >
                                        <Button
                                            className="btn-send-contact"
                                            key="sumit"
                                            htmlType="submit" >
                                            {t('contact_page_form.btn_send')}
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </Col>
                        </Row>
                    </Col>
                    <PopupCancelMemberShip />
                </Row >
            )
    )
}

export default translate()(ContactForm)
